/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'
import VueHead from 'vue-head'
// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


// axios
import axios from "./axios.js"
Vue.prototype.$http = axios
Vue.prototype.$axios = axios;

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
Vue.use(VueHead)
// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

const start = () => {
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
};

if (window.location.pathname !== "/connect/google" && localStorage.getItem("jwt") !== null) {
    axios.get("/users/me").then(res => {
      let user = res.data;
      // user.role.name = 'Authenticated'
      // user.hideMetadata = true;
      // user.role.name = 'Media'
      // user.role.name = 'AR Publisher'
      store.commit("setState", {user: user});
    }).catch(err => {
        localStorage.removeItem("jwt");
        delete axios.defaults.headers["Authorization"];
        this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: err.message || err})
    }).finally(() => {
        setTimeout(() => {
            store.commit("setState", {isLoading: false});
            start();
        }, 300)
    });
} else {
    store.commit("setState", {isLoading: false});
    start();
}


